module.exports = __webpack_public_path__ + "img/id-proof.4ca88eb9.svg";